import React, { useState, useMemo, useRef, useEffect } from "react";
import {
    MapContainer,
    TileLayer,
    Marker,
    useMapEvents,
    useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function MapEvents({ setPosition, position }) {
    const map = useMap();
    if (position) {
        map.flyTo(position, Math.max(14, map.getZoom()));
    }
    useMapEvents({
        click(e) {
            setPosition([e.latlng.lat, e.latlng.lng]);
        },
    });
}

function LocationMarker({ position, setPosition, type }) {
    const icon = new L.Icon({
        iconUrl: `/static/img/community/${type}.svg`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
    });
    const markerRef = useRef(null);

    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current;
                if (marker != null) {
                    console.log(marker.getLatLng());
                    const latLng = marker.getLatLng();
                    setPosition([latLng.lat, latLng.lng]);
                }
            },
        }),
        []
    );

    return position ? (
        <Marker
            ref={markerRef}
            position={position}
            icon={icon}
            draggable={true}
            eventHandlers={eventHandlers}
        ></Marker>
    ) : null;
}

function MapLocationPicker({ fieldValue, setFieldValue, addressFields, type }) {
    const [position, setPosition] = useState(fieldValue);

    const handleAddressFieldUpdate = (e) => {
        const address = [...addressFields]
            .map((field) => field.value)
            .join(", ");
        fetch(
            "/account/community/geocode/?" +
                new URLSearchParams({
                    address: address,
                })
        )
            .then((response) => response.json())
            .then((data) => {
                if (data && data.length === 2) {
                    updatePosition(data);
                }
            });
    };

    useEffect(() => {
        if (addressFields) {
            addressFields.forEach((field) =>
                field.addEventListener("blur", handleAddressFieldUpdate)
            );
        }
        return () => {
            if (addressFields) {
                addressFields.forEach((field) =>
                    field.removeEventListener("blur", handleAddressFieldUpdate)
                );
            }
        };
    }, [addressFields]);

    const updatePosition = (position) => {
        setPosition(position);
        setFieldValue(position);
    };

    return (
        <MapContainer
            style={{ height: "100%", width: "100%", cursor: "crosshair" }}
            attributionControl={false}
            zoom={6}
            center={[52.451521, -1.7228148]}
            minZoom={6}
            maxZoom={18}
        >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <MapEvents setPosition={updatePosition} position={position} />
            <LocationMarker
                position={position ? [position[0], position[1]] : null}
                setPosition={updatePosition}
                type={type}
            />
        </MapContainer>
    );
}

export default MapLocationPicker;
